import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import Layout from '/src/components/@common.blocks/Layout'
import NFTWhitelist from '/src/components/@sections/NFTWhitelist'

const WhitelistPage = ({ collection }) => {
  if (!collection) return ''
  return (
    <Layout
      title={collection.name}
      description={`Get whitelisted on ${collection.name}`}
      previewImage={collection.previewImage}
      header={false}
      footer={false}
      className='page-whitelist'
    >
      <GoogleReCaptchaProvider
        reCaptchaKey='6Lefw2UfAAAAAPeu3i_pH5MchnnHt4wcrnnyzotx'
        scriptProps={{
          async: false,
        }}
      >
        <NFTWhitelist collection={collection} />
      </GoogleReCaptchaProvider>
    </Layout>
  )
}

export async function getServerSideProps(ctx) {
  const { slug } = ctx.query
  if (slug !== 'rabbitzz') {
    return {
      props: {},
    }
  }
  return {
    props: {
      collection: {
        name: 'Rabbitzz',
        previewImage: '/preview.jpeg',
      },
    },
  }
}

export default WhitelistPage
